var mergeThemes = function mergeThemes(baseTheme) {
  for (var _len = arguments.length, themes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    themes[_key - 1] = arguments[_key];
  }

  if (themes) {
    return themes.reduce(function (acc, theme) {
      if (typeof theme === 'function') {
        theme = theme(baseTheme);
      }

      return Object.assign({}, acc, theme);
    }, baseTheme);
  }

  return baseTheme;
};

export default mergeThemes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/mergeThemes.js
// module id = 1201
// module chunks = 0